import { TEXT_BLOCK_SETTING } from '@/constants/elements/text-block';
import { HEADING_SETTING } from '@/constants/elements/heading';
import { BUTTON_SETTING } from '@/constants/elements/button';
export const SETTING_ELEMENTS = {
  heading: HEADING_SETTING,
  'text-block': TEXT_BLOCK_SETTING,
  button: BUTTON_SETTING,
};
